import React from "react";
import { Panel, PanelType } from "@fluentui/react/lib/Panel";

export enum RigthPanelType {
  small = PanelType.smallFixedFar,
  medium = PanelType.medium,
  large = PanelType.large,
}

const getPanelType = (rigthPanelType: RigthPanelType | undefined) => {
  return rigthPanelType as unknown as PanelType;
};

interface Props {
  header: string;
  isOpen: boolean;
  childComponent: any;
  childProps?: any;
  type?: RigthPanelType;
  dismissPanel?: () => any;
}

const RigthPanel = (props: Props) => {
  return (
    <>
      <div>
        <Panel
          type={getPanelType(props.type) ?? RigthPanelType.medium}
          headerText={props.header}
          isOpen={props.isOpen}
          onDismiss={props.dismissPanel}
          closeButtonAriaLabel="Close"
        >
          <props.childComponent {...props.childProps} />
        </Panel>
      </div>
    </>
  );
};

export default RigthPanel;
